<template>
  <v-dialog v-model="dialog" width="900" scrollable persistent>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Tambah Organisasi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item class="primary--text font-weight-medium" @click="onBack" style="cursor:pointer;">
            <v-icon color="primary" left>mdi-home</v-icon>Pilih Tenant
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider></v-breadcrumbs-divider>
          <v-breadcrumbs-item v-if="tenant" class="primary--text font-weight-medium">
            {{ tenant }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-text-field
          v-model="keyword"
          outlined
          dense
          placeholder="Pencarian Data"
          append-icon="mdi-magnify"
          @click:append="onSearch"
          @keydown.enter="onSearch"
        ></v-text-field>

        <v-list v-if="items.length">
          <v-list-item three-line v-for="(item, i) in items" :key="i" @click="onSelect(item)">
            <v-list-item-avatar>
              <v-img :src="item.file_foto || 'img/tenant-default.png'"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.nama }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ item.email }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.alamat }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </v-list>
        <v-alert v-else text type="warning">
          Belum ada data ditemukan
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      items: [],
      tenant: null,
      resolve: null,
      reject: null,
      keyword: '',
      tenant_id: null,
    }
  },
  methods: {
    open() {
      this.reset()
      this.fetchTenant()

      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    reset() {
      this.items = []
      this.tenant = null
      this.tenant_id = null
    },

    close() {
      this.dialog = false
    },

    fetchTenant() {
      this.$store
        .dispatch('tenant/get', { count: 100, keyword: this.keyword || '' })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },

    fetchOrganisasi(id) {
      this.$store
        .dispatch('organisasi/get', {
          kode_tenant: id,
          count: 100,
          keyword: this.keyword || '',
        })
        .then(({ data }) => {
          this.tenant_id = id
          this.page = data
          this.items = data.data
        })
        .then(() => {})
        .catch((e) => e)
    },

    onSelect(item) {
      if (item.tenant_id) {
        this.tenant = item.nama
        this.fetchOrganisasi(item.no_reg)
        this.keyword = ''
      } else {
        this.resolve(item)
      }
    },

    onBack() {
      this.tenant = null
      this.tenant_id = null
      this.keyword = null
      this.fetchTenant()
    },

    onSearch() {
      if (this.tenant) {
        this.fetchOrganisasi(this.tenant_id)
      } else {
        this.fetchTenant()
      }
    },
  },
}
</script>
